let nativePay = {
  wechatAppPay(payInfo){
    PayInterface.WechatPay(payInfo);
  },
  alipayAppPay(payInfo, returnUrl){
    PayInterface.AliPay(payInfo, returnUrl);
  },
  alipayH5Pay(payInfo){
    PayInterface.AliPayH5(payInfo);
  }
}
export default nativePay;



// WEBPACK FOOTER //
// ./src/assets/js/native-pay.js